export default {
  version: 'master',
  compilation: '282215'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1477
// module chunks = 22